import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const KalkulationsGruppeServiceConfig = {
  name: "KalkulationsGruppe",
  annotations: []
} as ServiceConfig;